import { Controller } from '@hotwired/stimulus'

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['icon']
    static values = { lotNumber: Number }

    declare lotNumberValue: number

    declare readonly iconTarget: HTMLElement
    declare readonly hasIconTarget: boolean

    private status: boolean = false
    private isSendingRequest = false

    connect() {
        window.addEventListener('favorite:toggle', this.handleFavoriteToggle as EventListener)

        requestAnimationFrame(() => requestAnimationFrame(() => this.updateStatusFromServer()))
    }

    disconnect() {
        window.removeEventListener('favorite:toggle', this.handleFavoriteToggle as EventListener)
    }

    handleFavoriteToggle = (event: CustomEvent) => {
        const { lotNumber, status } = event.detail

        if (lotNumber !== this.lotNumberValue) {
            return
        }

        this.setStatus(status)
    }

    async toggle(event: Event) {
        event.preventDefault()

        if (this.isSendingRequest) {
            return
        }

        this.isSendingRequest = true

        try {
            const response = await fetch(`/api/favorites/${this.lotNumberValue}`, {
                method: this.status ? 'DELETE' : 'POST',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                credentials: 'same-origin',
            })

            if (response.ok) {
                window.dispatchEvent(new CustomEvent('favorite:toggle', { detail: { lotNumber: this.lotNumberValue, status: !this.status } }))
            }
        } catch {} finally {
            this.isSendingRequest = false
        }
    }

    async updateStatusFromServer() {
        try {
            this.isSendingRequest = true

            const response = await fetch(`/api/favorites/${this.lotNumberValue}/status`, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                credentials: 'same-origin',
            })

            if (!response.ok) {
                return
            }

            const { status } = await response.json()

            this.setStatus(status)
        } catch {} finally {
            this.isSendingRequest = false
        }
    }

    setStatus(status: boolean) {
        this.status = status

        if (this.hasIconTarget) {
            this.iconTarget.classList.remove('heart', 'heart-filled')
            this.iconTarget.classList.add(status ? 'heart-filled' : 'heart')
        }
    }
}
